import { z } from 'zod';
import { createToolSignature } from './tool-signature';

export const updatePlaybooksToolSignature = createToolSignature({
    name: 'updatePlaybook',
    description: 'Update the purpose, target group, or context of a specific playbook',
    inputSchema: z.object({
        assistantSettingsId: z.string(),
        purpose: z
            .string()
            .describe('The purpose of the playbook. Provide an empty string if you dont want to change it.'),
        targetGroup: z
            .string()
            .describe('The target group of the playbook. Provide an empty string if you dont want to change it.'),
        context: z
            .string()
            .describe(
                'Any additional context that is needed in the context of achieving the purpose (e.g. booking links, product information, etc.). Provide an empty string if you dont want to change it.',
            ),
    }),
    outputSchema: z.object({
        success: z.boolean(),
    }),
    toolCallUi: (input) => `Updating playbook`,
});
